import ApiService from './api.service';

export function setHeader() {
  ApiService.setHeader(
    `${process.env.VUE_APP_MAUTIC_API}/`,
    `Basic ${process.env.VUE_APP_MAUTIC_KEY}`
  );
}

export function create(params) {
  this.setHeader();
  return ApiService.post('contacts/new', params);
}

export default {
  setHeader,
  create,
};
